import { faGear } from '@fortawesome/pro-solid-svg-icons';

import { useTranslate } from '@growtherapy/i18n';
import { IconButtonProps } from '@growtherapy/sprout-ui';

import { ControlPanelButton, ControlPanelButtonTooltip } from '../../components';
import { DrawerButton, DrawerButtonProps } from '../../components/DrawerButton';

export function SettingsDrawerControl({
  drawerId,
  forDrawerStates,
  isSettingsDrawerOpen,
  onClick,
}: {
  drawerId: string;
  forDrawerStates: DrawerButtonProps<IconButtonProps>['forDrawerStates'];
  isSettingsDrawerOpen: boolean;
  onClick: () => void;
}) {
  const t = useTranslate();
  const label = isSettingsDrawerOpen
    ? t('telehealth-core:controls.closeSettings')
    : t('telehealth-core:controls.openSettings');
  return (
    <div className='hidden md:block relative'>
      <ControlPanelButtonTooltip childIsInteractive text={label}>
        <DrawerButton
          as={ControlPanelButton}
          forDrawerStates={forDrawerStates}
          className='hidden md:flex'
          aria-label={label}
          aria-expanded={isSettingsDrawerOpen}
          aria-controls={drawerId}
          iconDefinition={faGear}
          onClick={onClick}
        />
      </ControlPanelButtonTooltip>
    </div>
  );
}
